import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import IconAppleMusicSvg from "./assets/IconAppleMusicSvg";
import IconSpotifySvg from "./assets/IconSpotifySvg";
import IconYandexSvg from "./assets/IconYandexSvg";

import {
  FieldDesc,
  FieldName,
  SideMenuAlbumImg,
  SideMenuContainer,
  SideMenuContent,
  SideMenuContentInfo,
  SideMenuContentInfoField,
  SideMenuDesc,
  SideMenuInner,
  WhereToListen,
  WhereToListenIconWrapper,
  WhereToListenTitle,
} from "../styled";
import { transformKeysToCamelCase } from "../../../utils/utils";
import { useFooterPlayer } from "../../../contexts/FooterPlayerContext";

const InfoTrack = () => {
  const trackInfo = transformKeysToCamelCase(
    useSelector((state) => state.trackInfo.infoTrack),
  );

  const { footerPlayerRef } = useFooterPlayer();

  const releaseYear = useMemo(() => {
    return trackInfo.release ? trackInfo.release.split("-")[0] : "";
  }, [trackInfo.release]);

  return (
    <SideMenuContainer
      footerPlayerHeight={footerPlayerRef.current?.offsetHeight ?? 0}
    >
      <SideMenuInner>
        <SideMenuContent>
          <SideMenuAlbumImg src={trackInfo.cover?.big || "/coverMissing.png"} />
          {trackInfo.id && (
            <SideMenuContentInfo>
              {trackInfo.track && (
                <SideMenuContentInfoField>
                  <FieldName>Название</FieldName>
                  <FieldDesc>{trackInfo.track}</FieldDesc>
                </SideMenuContentInfoField>
              )}
              {trackInfo.artist && (
                <SideMenuContentInfoField>
                  <FieldName>Исполнитель</FieldName>
                  <FieldDesc>{trackInfo.artist}</FieldDesc>
                </SideMenuContentInfoField>
              )}
              {trackInfo.album && (
                <SideMenuContentInfoField>
                  <FieldName>Альбом</FieldName>
                  <FieldDesc>{trackInfo.album}</FieldDesc>
                </SideMenuContentInfoField>
              )}
              {releaseYear && (
                <SideMenuContentInfoField>
                  <FieldName>Год релиза</FieldName>
                  <FieldDesc>{releaseYear}</FieldDesc>
                </SideMenuContentInfoField>
              )}
              {trackInfo.genre && (
                <SideMenuContentInfoField>
                  <FieldName>Жанр</FieldName>
                  <FieldDesc>{trackInfo.genre}</FieldDesc>
                </SideMenuContentInfoField>
              )}
            </SideMenuContentInfo>
          )}
        </SideMenuContent>
        {trackInfo.wikipedia && (
          <SideMenuDesc>{trackInfo.wikipedia}</SideMenuDesc>
        )}

        <WhereToListen>
          <WhereToListenTitle>Где послушать</WhereToListenTitle>
          <WhereToListenIconWrapper>
            {!!trackInfo.yandexMusic.url && (
              <a
                href={trackInfo.yandexMusic.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconYandexSvg />
              </a>
            )}
            {!!trackInfo.appleMusic.url && (
              <a
                href={trackInfo.appleMusic.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconAppleMusicSvg />
              </a>
            )}
            {!!trackInfo.spotify.url && (
              <a
                href={trackInfo.spotify.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconSpotifySvg />
              </a>
            )}
          </WhereToListenIconWrapper>
        </WhereToListen>
      </SideMenuInner>
    </SideMenuContainer>
  );
};

export default InfoTrack;
